import ScoringResultsTable from './ScoringResultsTable';

export default ScoringResultsTable;


// WEBPACK FOOTER //
// ./src/features/reports/pages/scoring-results-report-page/scoring-results-table/index.js